import React, { Component } from 'react';

import './style.sass';
import CommonTitle from '../../../common-components/common-title';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

class Tasks extends Component {
    render() {
        return (
            <div className="tasks">
                <div className="tasks__inner">
                    <CommonTitle className="tasks__title">Задачи</CommonTitle>
                    <div className="tasks__wrapper">
                        <div className="tasks__wrapper-inner">
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                offset={100}
                                animateOnce={true}
                                duration={1}
                            >
                                <div className="tasks__task">
                                    Анализ особенностей аудитории, заинтересованной в&nbsp;покупке
                                    полуприцепов.
                                    <div className="tasks__number">01</div>
                                </div>
                            </ScrollAnimation>

                            <ScrollAnimation
                                animateIn="fadeInUp"
                                offset={100}
                                animateOnce={true}
                                duration={1}
                            >
                                <div className="tasks__task">
                                    Разработка общей стратегии рекламной кампании и&nbsp;креативов.
                                    <div className="tasks__number">02</div>
                                </div>
                            </ScrollAnimation>

                            <ScrollAnimation
                                animateIn="fadeInUp"
                                offset={100}
                                animateOnce={true}
                                duration={1}
                            >
                                <div className="tasks__task">
                                    Генерация гипотез под каждую аудиторию
                                    и&nbsp;их&nbsp;тестирование.
                                    <div className="tasks__number">03</div>
                                </div>
                            </ScrollAnimation>
                        </div>

                        <div className="tasks__wrapper-inner">
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                offset={100}
                                animateOnce={true}
                                duration={1}
                            >
                                <div className="tasks__task">
                                    Поиск новых способов получения трафика для каждого вида техники.
                                    <div className="tasks__number">04</div>
                                </div>
                            </ScrollAnimation>

                            <ScrollAnimation
                                animateIn="fadeInUp"
                                offset={100}
                                animateOnce={true}
                                duration={1}
                            >
                                <div className="tasks__task">
                                    Запуск рекламных кампаний в&nbsp;выбранных каналах.
                                    <div className="tasks__number">05</div>
                                </div>
                            </ScrollAnimation>

                            <ScrollAnimation
                                animateIn="fadeInUp"
                                offset={100}
                                animateOnce={true}
                                duration={1}
                            >
                                <div className="tasks__task">
                                    Соблюдение KPI и&nbsp;масштабирование.
                                    <div className="tasks__number">06</div>
                                </div>
                            </ScrollAnimation>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Tasks;
